import { render, staticRenderFns } from "./ToolbarActionButton.vue?vue&type=template&id=520098b0&"
import script from "./ToolbarActionButton.vue?vue&type=script&lang=ts&"
export * from "./ToolbarActionButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports